import {
    Smartphone,
    BarChart3,
    Mail,
    Headset
} from "lucide-react";

export default function WebBuilderFeatures() {
    return (
        <section className="relative w-full pb-20 md:pt-8 lg:pb-24 bg-[#1a1a1a]">
            <div className="container">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                    
                    {/* Left side - Heading */}
                    <div className="lg:col-span-3">
                        <h2 className="text-2xl lg:text-3xl font-bold text-white leading-tight">
                            Included in every plan
                        </h2>
                    </div>

                    {/* Right side - Features grid */}
                    <div className="lg:col-span-9">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-6">

                            {/* Feature 1 */}
                            <div className="space-y-3">
                                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30">
                                    <Smartphone className="w-7 h-7 text-purple-400" />
                                </div>
                                <h3 className="text-white font-semibold text-base">
                                    Fully responsive website
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed">
                                    Optimized to work smoothly across phones, tablets, and desktops.
                                </p>
                            </div>

                            {/* Feature 2 */}
                            <div className="space-y-3">
                                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30">
                                    <BarChart3 className="w-7 h-7 text-purple-400" />
                                </div>
                                <h3 className="text-white font-semibold text-base">
                                    Performance insights
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed">
                                    Track activity, engagement, and growth in real time.
                                </p>
                            </div>

                            {/* Feature 3 */}
                            <div className="space-y-3">
                                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30">
                                    <Mail className="w-7 h-7 text-purple-400" />
                                </div>
                                <h3 className="text-white font-semibold text-base">
                                    Branded business email
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed">
                                    Create a professional email address using your domain name.
                                </p>
                            </div>

                            {/* Feature 4 */}
                            <div className="space-y-3">
                                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30">
                                    <Headset className="w-7 h-7 text-purple-400" />
                                </div>
                                <h3 className="text-white font-semibold text-base">
                                    24/7 support assistance
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed">
                                    Get help anytime from our experienced support team.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
